<template>
  <div id="app">
    <Navbar />

    <router-view />
  </div>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Navbar from "../src/components/Navbar.vue";
import { mapGetters } from "vuex";

@Component({
  components: {
    Navbar,
  },
  computed: {
    ...mapGetters(["language"]),
  },
})
export default class App extends Vue {
  language!: string; // <- for static type checking

  mounted() {
    this.setDefaultLanguage();
    this.setupScrollbarHover();
  }

  setDefaultLanguage() {
    const userLang = navigator.languages[1];

    if (userLang) {
      this.$store.dispatch("setLanguage", userLang);

      this.$i18n.locale = this.language;
    }
  }

  setupScrollbarHover() {
    document.addEventListener('mousemove', (e) => {
      const windowWidth = window.innerWidth;
      const mouseX = e.clientX;

      // Si el mouse está a menos de 30px del borde derecho, consideramos que está sobre el scrollbar
      if (windowWidth - mouseX < 30) {
        document.body.classList.add('hover-scrollbar');
      } else {
        document.body.classList.remove('hover-scrollbar');
      }
    });
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  //overflow-x: hidden;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

@font-face {
  font-family: "Raleway";
  src: local("Raleway"),
    url(./assets/Raleway-VariableFont_wght.ttf) format("truetype");
}

.highlighted {
  background-color: #42b983;
}

// Custom scrollbar.
body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

body::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
  transition: width 0.3s ease;
}

body.hover-scrollbar::-webkit-scrollbar {
  width: 14px;
}

body::-webkit-scrollbar-thumb {
  background-color: #0d4154;
  border-radius: 4px;
  transition: all 0.3s ease;
}
</style>
